/*
Enable the "Request Desktop Site" functions on mobile chrome (android and iOS) allow users to see desktop layouts on responsive sites.  Note that this is distinct from "opt out of mobile!" buttons built into your site: this is meant to work with the browser's native opt-in/opt-out functionality.
Since these functions work, in part, by simply spoofing the user agent to pretend to be desktop browsers, all we have to do is just remember that the browser once claimed to be android earlier in the same session and then alter the viewport tag in response to its fib.
Here's an example viewport tag <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"> that we'd be setting to scaleable-yes,max scale=2.  That's just an example of something that works on the site I was building: you should customize the "desktop" viewport content setting to whatever works for your site's needs.  If you wanted, you could stick this code in the head just after the primary viewport tag so that the browser doesn't have to re-render the page so much.  Myself, I prefer to leave it at the bottom, since it's a non-critical, probably rarely used, feature at this point: those people who do use it can handle a little extra repaint time.  I was surprised that the Firefox workaround actually works with the code outside of the head, but it does.
*/
var globalWasAndroid = false;
var leadOrigin;
(function (d) {
  //quick dookie checker
  function C(k) {
    return (d.cookie.match('(^|; )' + k + '=([^;]*)') || 0)[2];
  }

  var ua = navigator.userAgent, // get the user agent string
    ismobile = / mobile/i.test(ua), // android and firefox mobile both use android in their UA, and both remove it from the UA in their "pretend desktop mode"
    mgecko = !!(/ gecko/i.test(ua) && / firefox\//i.test(ua)), //test for firefox
    wasmobile = C('wasmobile') === 'was', // save the fact that the browser once claimed to be mobile
    desktopvp = 'user-scalable=yes, maximum-scale=2',
    el;

  if (ismobile && !wasmobile) {
    d.cookie = 'wasmobile=was'; //if the browser claims to be mobile and doesn't yet have a session cookie saying so, set it
  } else if (!ismobile && wasmobile) {
    //if the browser once claimed to be mobile but has stopped doing so, change the viewport tag to allow scaling and then to max out at whatever makes sense for your site (could use an ideal max-width if there is one)
    globalWasAndroid = true;
  }
})(document);
/**********************************/

/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
function getCalCookie (name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}

const geoRegion = getCalCookie('wp-geo_region');

var $ = jQuery.noConflict();

$(document).ready(function () {

  var checkWhiteSpaces = function (value) {
    return $.trim(value).length == 0;
  };

  $('.request-consultation-drop-loader').hide();

  /**
   * Form step 1 validation and submission
   */
  $('form.request-consult-form, form.rfc-request-consult-form').on('submit', function (e) {
    e.preventDefault();

    if( typeof geoRegion !== 'undefined' && typeof geoRegionConditions !== 'undefined'){
      
      if(geoRegionConditions.includes(geoRegion)){
        if ($(this).find('.customer_consent').prop('checked')) {
          console.log('proceed!');
        } else{
          cc_consent_modal(e.target);
          return;
        }
      }
    }

    var $requestBtn = $(this).find('.btn');

    $requestBtn.prop('disabled', true);

    var ajaxdata = $(this).serialize() + '&action=request_consultation_form_step_1&wpml_lang=' + wpml_lang;

    var popUP = $(this).parents('.rfc-pop-up').length,
      popUpB = $(this).parents('.pop-up-form-container').length,
      parentForm = $(this),
      storePopup = false,
      formErrors = false;

    $(parentForm).find('p.error-message').remove();
    $(parentForm).find('input').css('border-color', '#000');
    $(parentForm).find('.errors_below').css('display', 'none');
    $('form.request-consult-form .fa').css('display', 'none');

    if (popUpB > 0) {
      if (
        $(this).parents('.pop-up-form-container').attr('data-store') &&
        $(this).parents('.pop-up-form-container').attr('data-store') != ''
      ) {
        storePopup = $(this).parents('.pop-up-form-container').attr('data-store');
      }
    }

    if (
      $(parentForm).find('#request-fname, .request-fname').val().length == 0 ||
      checkWhiteSpaces($(parentForm).find('#request-fname, .request-fname').val())
    ) {
      $(parentForm)
        .find('#request-fname, .request-fname')
        .after('<p role="alert" class="error-message">' + errors.first_name + '</p>');
      $(parentForm).find('#request-fname, .request-fname').css('border-color', '#f00');
      $(parentForm).find('#request-fname_fa').css('display', 'block');

      $requestBtn.prop('disabled', false);

      formErrors = true;
    }

    if (
      $(parentForm).find('#request-lname, .request-lname').val().length == 0 ||
      checkWhiteSpaces($(parentForm).find('#request-lname, .request-lname').val())
    ) {
      $(parentForm)
        .find('#request-lname, .request-lname')
        .after('<p role="alert" class="error-message">' + errors.last_name + '</p>');
      $(parentForm).find('#request-lname, .request-lname').css('border-color', '#f00');
      $(parentForm).find('#request-lname_fa').css('display', 'block');

      $requestBtn.prop('disabled', false);

      formErrors = true;
    }

    if (
      $(parentForm).find('#request-email, .request-email').val().length == 0 ||
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        $(parentForm).find('#request-email, .request-email').val()
      )
    ) {
      $(parentForm)
        .find('#request-email, .request-email')
        .after('<p role="alert" class="error-message">' + errors.email + '</p>');
      $(parentForm).find('#request-email, .request-email').css('border-color', '#f00');
      $(parentForm).find('#request-email_fa').css('display', 'block');

      $requestBtn.prop('disabled', false);

      formErrors = true;
    }

    var value = $(parentForm).find('#request-phone, .request-phone').val();
    value = value.replace(/-/g, '');

    if (value == '0000000000' || !/^[0-9]*$/.test(value) || value.length < 10 || value.length > 10) {
      $(parentForm)
        .find('#request-phone, .request-phone')
        .after('<p role="alert" class="error-message">' + errors.pop_up_form_usa_phone_hint + '</p>');
      $(parentForm).find('#request-phone, .request-phone').css('border-color', '#f00');
      $(parentForm).find('#request-phone_fa').css('display', 'block');

      $requestBtn.prop('disabled', false);

      formErrors = true;
    }

    var zipVal = $(parentForm).find('#request-city, .request-city').val();
    var $zipField = $(parentForm).find('#request-city, .request-city');

    if (!/^([a-zA-Z][0-9][a-zA-Z])\s*([0-9][a-zA-Z][0-9])$/.test(zipVal)) {
      $zipField.after('<p role="alert" class="error-message">' + errors.us_zip_error + '</p>');
      $zipField.after('<p role="alert" class="error-message">' + errors.zipcode + '</p>');

      $zipField.css('border-color', '#f00');
      $(parentForm).find('#request-city_fa').css('display', 'block');

      $requestBtn.prop('disabled', false);

      formErrors = true;
    }

    if (formErrors) {
      $(parentForm).find('.errors_below').css('display', 'block');
      return false;
    }

    if (formErrors == false) {
      $(parentForm).find('.request-consultation-drop-loader').show()
          .find('.cc-loading-spinner--screen-reader').text(function (){return $(this).data('loading-label')});

      var pathArray = window.location.pathname.split('/');

      if (pathArray[pathArray.length - 2] == 'syracuse' && pathArray[pathArray.length - 4] != 'our-work') {
        setCookiesPopup('market-request-form-step-two', 'syracuse', 1);
        setCookiesPopup('market-request-form', 'syracuse', 1);
      }

      window.dataLayer = window.dataLayer || [];

      $.post(ajaxurl, ajaxdata, function (res) {

        if(res.errors){
          if(res.errors.consent_status){
            
          }
        }

        $('.request-consultation-drop-loader').hide();
        $('.bookNow_inputwrap').append(res);

        setTimeout(function () {
          $('.request-consult-form input').css({
            'border-color': '#333',
          });

          $('.intake-response p.success-message').remove();
        }, 5000);

        if (res.indexOf('window.location.href') > -1) {
          if ($('#privacy-check, .privacy-check').prop('checked')) {
            window.dataLayer.push({
              event: 'subscribeToNewsletterStep1',
            });
          }

          if (popUP > 0) {
            window.dataLayer.push({
              event: 'formSubmitPopup',
            });
          } else if (popUpB > 0) {
            if (storePopup) {
              window.dataLayer.push({
                event: 'formSubmitPopupShowroom',
                showroomName: storePopup,
              });
            } else {
              window.dataLayer.push({
                event: 'formSubmitPopupB',
              });
            }
          } else {
            window.dataLayer.push({
              event: 'formSubmitStep1',
            });

            // Create an array of all url parameters
            const urlParams = new URLSearchParams(window.location.search);
            const urlParamsArray = Array.from(urlParams.keys());

            const ccArray = ['CC0', 'CC1', 'CC2', 'CC3', 'CC4', 'CC5', 'CC6'];

            // Search the urlParamsArray for any CC0-CC6 parameters
            const ccFound = urlParamsArray.some(r => ccArray.indexOf(r) >= 0);

            // If the urlParamsArray contains a CC code, set the lead_origin to 'yext canada'
            let leadOrigin = 'canada';

            if (ccFound) {
              leadOrigin = 'yext canada';
            }

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: 'rfc_step1_complete',
              lead_origin: leadOrigin,
            });

            localStorage.setItem('lead_origin', leadOrigin);
          }
        }
      });
    }

    return false;
  });


  /**
   * Consent Modal Actions
   */
  var lastFocus;

  $(document).on('show.bs.modal','#consentModal', function () {
    // $(lastFocus).find('[id^=privacy-check]').hide();
  });

  $(document).on('hidden.bs.modal','#consentModal', function () {
    if(lastFocus)
          lastFocus.focus();
          $(lastFocus).find('[id^=customer_consent]').prop('disabled',false);
  });

  $('.cc-consent-modal__agree').on('click', function (e) {
    $(lastFocus).find('[id^=customer_consent]').prop( "checked", true);
    $(lastFocus).submit();
  });
 
  function cc_consent_modal(e){
    console.log(e);
    lastFocus = e;
    $('#consentModal').modal('show');
  }
  

  /**
   * Form step 2 validation and submission
   */
  $('button.continue').on('click', function () {

    $('form.request2step p.error-message').remove();

    var form = $(this).parents('form');
    var $requestBtn = $(this);

    $requestBtn.prop('disabled', true);

    if ($(form).find('[name="country"]').val().length < 2) {
      $(form)
        .find('[name="country"]')
        .after('<p role="alert" class="error-message">' + errors.country + '</p>');

      $requestBtn.prop('disabled', false);

      return false;
    }

    var zipVal = $(form).find('[name="zipcode"]').val();
    var $zipField = $(form).find('[name="zipcode"]');

    if (zipVal.length < 1) {
      $zipField.after('<p role="alert" class="error-message">' + errors.zipcode + '</p>');

      $requestBtn.prop('disabled', false);

      return false;
    }

    if (!/^([a-zA-Z][0-9][a-zA-Z])\s*([0-9][a-zA-Z][0-9])$/.test(zipVal)) {
      $zipField.after('<p role="alert" class="error-message">' + errors.us_zip_error + '</p>');
      $zipField.after('<p role="alert" class="error-message">' + errors.zipcode + '</p>');

      $requestBtn.prop('disabled', false);

      return false;
    }

    if ($(form).find('[name="country"]').val() == 'mx') {
      if (!/[0-9]{8,10}/.test($(form).find('[name="phone2"]').val())) {
        $(form)
          .find('[name="phone2"]')
          .after('<p role="alert" class="error-message">' + errors.popup_form_required_field + '</p>');
        $(form)
          .find('[name="phone2"]')
          .after('<p role="alert" class="error-message">' + errors.pop_up_form_phone_help_text + '</p>');
        $(form)
          .find('[name="phone2"]')
          .after('<p role="alert" class="error-message">' + errors.pop_up_form_mexico_phone_hint + '</p>');

        $requestBtn.prop('disabled', false);

        return false;
      }
    } else {
      var value = $(form).find('[name="phone2"]').val();
      value = value.replace(/-/g, '');

      if (value == '0000000000' || !/^[0-9]*$/.test(value) || value.length < 10 || value.length > 10) {
        $(form)
          .find('[name="phone2"]')
          .after('<p role="alert" class="error-message">' + errors.popup_form_required_field + '</p>');
        $(form)
          .find('[name="phone2"]')
          .after('<p role="alert" class="error-message">' + errors.pop_up_form_phone_help_text + '</p>');
        $(form)
          .find('[name="phone2"]')
          .after('<p role="alert" class="error-message">' + errors.pop_up_form_usa_phone_hint + '</p>');

        $requestBtn.prop('disabled', false);

        return false;
      }
    }

    var about_space = $(form).find('[name="about-your-space"]').val().trim();

    if (about_space.length != 0) {
      if (about_space.indexOf('<') != -1 || about_space.indexOf('>') != -1) {
        $(form)
          .find('[name="about-your-space"]')
          .after('<p role="alert" class="error-message">' + errors.step2_about_special_characters + '</p>');

        $requestBtn.prop('disabled', false);

        return false;
      }
    }

    // Customer Consent
    if( typeof geoRegion !== 'undefined' && typeof geoRegionConditions !== 'undefined'){

      if(geoRegionConditions.includes(geoRegion)){
        if ($(form).find('.customer_consent').prop('checked')) {
          console.log('proceed!');
        } else{
          $([document.documentElement, document.body]).animate({
            scrollTop: $(form).find('.consent_fields').offset().top-200
          }, 1000);
          $(form).find('.consent_fields').focus();
          $(form).find('.consent_fields .checkbox__option').after('<p role="alert" class="error-message">Consent must be given to proceed.</p>');
          $requestBtn.prop('disabled',false);

          $(form).find('.consent_fields .checkbox__option').css(
            'box-shadow',
            'inset 0px 0px 0px 2px rgb(255 0 0)'
          );

          setTimeout(function() { 
            $(form).find('.consent_fields .error-message').fadeOut(400);
            $(form).find('.consent_fields .checkbox__option').css(
              'box-shadow',
              'none'
            );
          }, 4000);
          
          return false;
        }
      }
    }


    var ajaxdata = $('.request2step').serialize() + '&action=request_consultation_form&wpml_lang=' + wpml_lang;

    $('form.request2step .request-consultation-drop-loader').show()
      .find('.cc-loading-spinner--screen-reader').text(function (){return $(this).data('loading-label')});
    $(this).attr('disabled', 'disabled');

    $.post(ajaxurl, ajaxdata, function (res) {
      $('.request-consultation-drop-loader').hide();
      $('.request-consult-form-res').html(res);
      $('button.continue').removeAttr('disabled');

      setTimeout(function () {
        $('.request-consult-form input').css({
          'border-color': '#333',
        });

        $('.intake-response p.success-message').remove();
      }, 5000);
    });

    let leadOriginStorage = localStorage.getItem('lead_origin');

    if (leadOriginStorage == null) {
      leadOrigin = 'canada';
    }

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'rfc_step2_complete',
      lead_origin: leadOriginStorage,
    });

    return false;
  });

  setTimeout(function () {
    usPhoneFormat('#request-form #request-phone');
    usPhoneFormat('#header-request-form #request-phone');
    usPhoneFormat('#popup-request-form #request-phone');
    usPhoneFormat('#rfc-request-form #request-phone');
    usPhoneFormat('#request-consult-form #request-phone');
    usPhoneFormat('form.request2step #request-phone');
  }, 2000);

  // Mobile RFC behavior.
  if ($(window).width() < 768 && $(window).scrollTop() > 0 && !$('body').hasClass('not-small')) {
    $('body').addClass('fixed-mobile');
  } else if ($(window).width() < 768) {
    $('body').removeClass('fixed-mobile');
  } else {
    $('.cta-request a').attr('href', '#rfc_popup_div');
    $('.cta-request a').addClass('popup_rfc');
    $('.cta-request a span').click(function () {
      $('.cta-request a').trigger('click');
    });
    $('.cta-request a p').click(function () {
      $('.cta-request a').trigger('click');
    });
  }
});

// Pop up form behavior.
$(document).on('click touchstart', '.cta-request *', function (e) {
  if ($(window).width() > 767) {
    e.preventDefault();
    e.stopPropagation();

    $('.rfc-pop-up-form-container').addClass('active');

    return false;
  }
});

// Pop up form close button.
$(document).on('click touchstart', '.rfc-pop-up-form-container.active .close-button', function (e) {
  e.preventDefault();
  e.stopPropagation();

  $(this).parents('.rfc-pop-up-form-container').removeClass('active');

  return false;
});

/**
 * Phone # Formatting Functionality.
 * @param {Node} inputElement - The input field to format.
 */
function usPhoneFormat(inputElement) {
  var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf('android') > -1; //&& ua.indexOf("mobile");

  if (!isAndroid && !globalWasAndroid) {
    var lastValue = null;
    //start
    if ($(inputElement).length > 0) {
      // input element exists
      if ($(inputElement).val() != '') {
        var digitsOnly = $(inputElement).val().replace(/\D/g, '');
        var digits = digitsOnly.split('');
        if (digits.length >= 3) {
          digits.splice(3, 0, '-');
        }
        if (digits.length >= 7) {
          digits.splice(7, 0, '-');
        }
        $(inputElement).val(digits.join(''));
      }
    }
    $(inputElement).on('keydown', function () {
      setTimeout(function () {
        var originalValue = $(inputElement).val();
        if (originalValue === lastValue) {
          return;
        }

        var selectionStart = $(inputElement).selectionStart,
          selectionEnd = $(inputElement).selectionEnd;
        var beforeCursor = originalValue.substring(0, selectionStart);
        var nonDigits = beforeCursor.replace(/\d/g, '');
        selectionStart -= nonDigits.length;
        selectionEnd -= nonDigits.length;

        var digitsOnly = originalValue.replace(/\D/g, '');
        var digits = digitsOnly.split('');

        if (digits.length > 3) {
          digits.splice(3, 0, '-');

          if (selectionStart > 3) {
            selectionStart++;
          }

          if (selectionEnd > 3) {
            selectionEnd++;
          }
        }

        if (digits.length > 7) {
          digits.splice(7, 0, '-');

          if (selectionStart > 7) {
            selectionStart++;
          }

          if (selectionEnd > 7) {
            selectionEnd++;
          }
        }

        lastValue = digits.join('');
        $(inputElement).val(lastValue);

        $(inputElement).selectionStart = selectionStart;
        $(inputElement).selectionEnd = selectionEnd;
      });
    });
    // end
  }
}
